"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Card_1 = require("@dialogexe/cw-component-card/Card");
const icons_1 = require("@dialogexe/cw-asset-provider/icons");
const moment = require("moment");
const BULLET_POINT = `\u2022`;
class Events extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedCategory: null
        };
        this.translateToNyNorsk = (value) => {
            switch (value) {
                case 'På kino nå':
                    return 'På kino no';
                case 'Kommende filmer':
                    return 'Komande filmar';
                default:
                    return value;
            }
        };
        const preferredLanguage = props.preferredLanguage ? props.preferredLanguage : 'nb';
        moment.locale(preferredLanguage);
    }
    render() {
        const { title, imagePlaceholder } = this.props;
        const cards = this.getFilteredCards();
        if (cards.length === 0) {
            return (React.createElement("div", null));
        }
        return (React.createElement("div", { className: "Events" },
            React.createElement("h1", { className: "title" }, title),
            this.renderFilter(),
            React.createElement("div", { className: "row is-spaced" }, cards.map((card, index) => (React.createElement("div", { key: index, className: "column is-lg-3 is-md-4 is-xs-6" },
                React.createElement(Card_1.Card, { image: card.image || imagePlaceholder, title: card.title, subtitle: this.formatSubtitle(card.subtitle, card.type), link: card.link, alternate: true })))))));
    }
    renderFilter() {
        const { preferredLanguage } = this.props;
        const selectedCategory = this.resolveSelectedCategory();
        let categories = this.getDistinctCategories();
        if (!this.isDisplayTypeMovies() && categories.length <= 1) {
            return (React.createElement("div", null));
        }
        return (React.createElement("nav", { className: "filter" },
            React.createElement("div", { className: "tabs is-hidden-mobile" },
                !this.isDisplayTypeMovies() && (React.createElement("a", { href: "#", className: `tab ${selectedCategory === null ? 'is-active' : ''}`, onClick: (e) => { e.preventDefault(); this.onCategorySelect.bind(this)(null); } }, "Alle")),
                categories.map((category, i) => (React.createElement("a", { key: i, href: "#", className: `tab ${category === selectedCategory ? 'is-active' : ''}`, onClick: (e) => { e.preventDefault(); this.onCategorySelect.bind(this)(category); } }, preferredLanguage === 'nn' ? this.translateToNyNorsk(category) : category)))),
            React.createElement("div", { className: "is-hidden-tablet" },
                React.createElement("div", { className: "input" },
                    React.createElement("select", { className: "", onChange: (e) => {
                            e.target.value === '' ?
                                this.setState({ selectedCategory: null }) :
                                this.setState(({ selectedCategory: e.target.value }));
                        } }, categories.map((category, i) => (React.createElement("option", { value: category, key: i }, category)))),
                    React.createElement("i", { className: "" },
                        React.createElement("img", { src: icons_1.arrowheadDownIcon, alt: "" }))))));
    }
    onCategorySelect(category) {
        this.setState({
            selectedCategory: category
        });
    }
    formatSubtitle(subtitle, type) {
        if (!moment(subtitle).isValid()) {
            return subtitle;
        }
        if (this.isDisplayTypeMovies() && type === 'movie_coming') {
            return 'Premiere ' + moment(subtitle).format('ll');
        }
        if (this.isDisplayTypeMovies() && type === 'movie') {
            return '';
        }
        const day = this.capitalizeFirstLetter(moment(subtitle).format("dddd"));
        return `${day} ${moment(subtitle).format("DD. MMMM")} ${BULLET_POINT} ${moment(subtitle).format("HH:mm")}`;
    }
    capitalizeFirstLetter(text) {
        return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    }
    isDisplayTypeMovies() {
        const { displayType } = this.props;
        return displayType === 'movies';
    }
    getFilteredCards() {
        const { cards } = this.props;
        const selectedCategory = this.resolveSelectedCategory();
        const filterBySelectedCategory = cards.filter(card => (selectedCategory === null || card.category === selectedCategory));
        const groupedByCategory = this.isDisplayTypeMovies() ? this.getUniqueCards(filterBySelectedCategory) : filterBySelectedCategory;
        return groupedByCategory.sort((c1, c2) => (moment(c1.date).unix() - moment(c2.date).unix()));
    }
    resolveSelectedCategory() {
        const { selectedCategory } = this.state;
        const categories = this.getDistinctCategories(true);
        if (!this.isDisplayTypeMovies() || selectedCategory !== null) {
            return this.state.selectedCategory;
        }
        let preselectMoviesCat = '';
        if (typeof categories['movie'] !== 'undefined') {
            preselectMoviesCat = categories['movie'];
        }
        else if (typeof categories['movie_coming'] !== 'undefined') {
            preselectMoviesCat = categories['movie_coming'];
        }
        return preselectMoviesCat;
    }
    getDistinctCategories(returnMap = false) {
        const { cards } = this.props;
        let categories = {};
        if (returnMap) {
            cards.forEach(card => {
                categories[card.type] = card.category;
            });
            return categories;
        }
        cards.forEach(card => {
            categories[card.category] = '';
        });
        return Object.keys(categories);
    }
    getUniqueCards(cards = []) {
        let uniqueCards = [];
        cards.forEach((card) => {
            const existingEvent = uniqueCards.find(e => e.link === card.link);
            if (!existingEvent) {
                uniqueCards.push(card);
            }
        });
        return uniqueCards;
    }
}
exports.Events = Events;
exports.default = Events;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-events/Events.tsx